(() => {
  const isCartPath = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(location.pathname);
  if (!isCartPath) return;

  const bindCheckoutButtons = () => {
    document.querySelectorAll('form[action*="/cart"], form#cart').forEach(form => {
      form.setAttribute('target', '_top');
    });

    document.querySelectorAll('button[name="checkout"], input[name="checkout"], a[href*="/checkout"]').forEach(control => {
      if (control.dataset.evasimCheckoutTopBound) return;
      control.dataset.evasimCheckoutTopBound = '1';
      const form = control.form || control.closest('form');
      if (form) form.setAttribute('target', '_top');
    });
  };

  bindCheckoutButtons();
  document.addEventListener('DOMContentLoaded', bindCheckoutButtons);
  new MutationObserver(bindCheckoutButtons).observe(document.documentElement, { childList: true, subtree: true });
})();